var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2630_18946)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.5C13.6944 17.5 17.5 13.6944 17.5 9C17.5 4.30558 13.6944 0.5 9 0.5C4.30558 0.5 0.5 4.30558 0.5 9C0.5 13.6944 4.30558 17.5 9 17.5Z",
    stroke: "#2A2D34"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2630_18946",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9C14 9.98891 13.7068 10.9556 13.1573 11.7779C12.6079 12.6001 11.827 13.241 10.9134 13.6194C9.99979 13.9978 8.99445 14.0969 8.02455 13.9039C7.05464 13.711 6.16373 13.2348 5.46447 12.5355C4.7652 11.8363 4.289 10.9454 4.09607 9.97545C3.90315 9.00555 4.00216 8.00021 4.3806 7.08658C4.75904 6.17295 5.3999 5.39206 6.22215 4.84265C7.04439 4.29324 8.01109 4 9 4V9H14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2630_18946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 9C14 9.98891 13.7068 10.9556 13.1573 11.7779C12.6079 12.6001 11.827 13.241 10.9134 13.6194C9.99979 13.9978 8.99445 14.0969 8.02455 13.9039C7.05464 13.711 6.16373 13.2348 5.46447 12.5355C4.7652 11.8363 4.289 10.9454 4.09607 9.97545C3.90315 9.00555 4.00216 8.00021 4.3806 7.08658C4.75904 6.17295 5.3999 5.39206 6.22215 4.84265C7.04439 4.29324 8.01109 4 9 4V9H14Z",
    stroke: "#2A2D34",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2630_18946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.535628ce111af4e245ef841777e119a5.svg";
export { ForwardRef as ReactComponent };